import React from "react";

const DocumentTextIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>document-text-icon</title>
      <path
        d="M12 16H3c-.532 0-1.04-.212-1.417-.588-.375-.377-.585-.887-.583-1.42V2.008C1 .9 1.894.003 3 0h6.5c.582.017 1.137.248 1.56.65l2.29 2.287c.4.425.63.98.65 1.564V14c.002.53-.21 1.04-.584 1.416-.375.375-.885.586-1.416.584zM10 2.414V4h1.59L10 2.414zM12 6h-2c-1.105 0-2-.895-2-2V2c-1.92 0-5 0-5 .006V14h9V6zM5 4h1c.552 0 1 .448 1 1s-.448 1-1 1H5c-.552 0-1-.448-1-1s.448-1 1-1zm0 3h5c.552 0 1 .448 1 1s-.448 1-1 1H5c-.552 0-1-.448-1-1s.448-1 1-1zm0 3h5c.552 0 1 .448 1 1s-.448 1-1 1H5c-.552 0-1-.448-1-1s.448-1 1-1z"
        fill="#667085"
        fillRule="evenodd"
      />
    </svg>
  );
};
export default DocumentTextIcon;
